export default "__VITE_ASSET__D8AI0SmK__"